export default __webpack_public_path__ + "static/Logo-de6003d7a54b50a4ed00ccb2a4a02614.png";